import { render, staticRenderFns } from "./StoreLocatorConfigColorPicker.vue?vue&type=template&id=2c4e4068&scoped=true&"
import script from "./StoreLocatorConfigColorPicker.vue?vue&type=script&lang=js&"
export * from "./StoreLocatorConfigColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./StoreLocatorConfigColorPicker.vue?vue&type=style&index=0&id=2c4e4068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4e4068",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
installComponents(component, {VColorPicker})
